import { Reveal } from "@/components/Reveal";

export const PageHeader = ({ overline, title, lede, image, imageAlt }) => (
  <section data-testid="page-header" className="relative overflow-hidden border-b border-slate-200 bg-cream">
    <div className="grid-bg grid-fade absolute inset-0" aria-hidden />
    <div className={`relative mx-auto max-w-7xl px-4 pb-14 pt-16 sm:px-6 md:pb-20 md:pt-24 ${image ? "grid gap-10 lg:grid-cols-12 lg:items-center" : ""}`}>
      <div className={image ? "lg:col-span-7" : ""}>
      <Reveal y={12}>
        <p data-testid="page-header-overline" className="eyebrow">{overline}</p>
      </Reveal>
      <Reveal delay={0.08} y={16}>
        <h1 data-testid="page-header-title" className="mt-4 max-w-4xl font-display text-4xl font-bold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h1>
      </Reveal>
      {lede && (
        <Reveal delay={0.16} y={16}>
          <p data-testid="page-header-lede" className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">{lede}</p>
        </Reveal>
      )}
      </div>
      {image && (
        <Reveal delay={0.12} className="lg:col-span-5">
          <div className="card overflow-hidden">
            <img data-testid="page-header-image" src={image} alt={imageAlt || ""} className="h-56 w-full object-cover md:h-72" loading="eager" />
          </div>
        </Reveal>
      )}
    </div>
  </section>
);
